import { kDPIScreen } from "../constants";
import { QRect } from "../CoreApp/QRect";

export function GetStdMargins() {
  var marginRect = new QRect();
  marginRect.InitRect(0.25, 0.25, 0.25, 0.25);
  marginRect = marginRect.MultiplyRect(kDPIScreen); // FIXME - not necessarily an integer results
  return marginRect;
}
